
export class BlobPicture
{
    public Image: Blob;
    public PictureTime: Date;
    public IndexFromDevice: number = 0;
    // public Oryginal: ArrayBuffer;

    constructor(
        image: Blob,
        creationTime?: Date,
        indexFromDevice?: number)
    {
        this.Image = image;
        this.PictureTime = creationTime || new Date(0);
        this.IndexFromDevice = indexFromDevice ?? 0;
    }
}
